import { SNACKBAR_ACTIONS } from 'config';

const initialState = {
  action: false,
  open: false,
  message: 'Note archived',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  variant: 'default',
  alert: {
    color: 'primary',
    variant: 'filled'
  },
  transition: 'Fade',
  close: true,
  actionButton: false,
  maxStack: 3,
  dense: false,
  iconVariant: 'usedefault'
};

const snackbar = (state = initialState, action) => {
  switch (action.type) {
    case SNACKBAR_ACTIONS.OPEN_SNACKBAR: {
      const { open, message, anchorOrigin, variant, alert, transition, close, actionButton } = action.payload;
      return {
        ...state,
        action: !state.action,
        open: open || initialState.open,
        message: message || initialState.message,
        anchorOrigin: anchorOrigin || initialState.anchorOrigin,
        variant: variant || initialState.variant,
        alert: {
          color: alert?.color || initialState.alert.color,
          variant: alert?.variant || initialState.alert.variant
        },
        transition: transition || initialState.transition,
        close: close === false ? close : initialState.close,
        actionButton: actionButton || initialState.actionButton
      };
    }
    case SNACKBAR_ACTIONS.CLOSE_SNACKBAR: {
      return {
        ...state,
        open: false
      };
    }
    case SNACKBAR_ACTIONS.HANDLER_INCREASE: {
      const { maxStack } = action.payload;
      return {
        ...state,
        maxStack: maxStack
      };
    }
    case SNACKBAR_ACTIONS.HANDLER_DENSE: {
      const { dense } = action.payload;
      return {
        ...state,
        dense: dense
      };
    }
    case SNACKBAR_ACTIONS.HANDLER_ICON_VARIANTS: {
      const { iconVariant } = action.payload;
      return {
        ...state,
        iconVariant: iconVariant
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default snackbar;